import { createSlice } from "@reduxjs/toolkit";

const inventorySlice = (name, defaultSortField = "created", defaultSortOrder = "desc") => {
  const initialState = {
    pagination: { page: 0, pageSize: 15 },
    sortModel: [{ field: defaultSortField, sort: defaultSortOrder }],
    searchText: "",
  };

  const slice = createSlice({
    name,
    initialState,
    reducers: {
      setPagination: (state, action) => {
        state.pagination = action.payload;
      },
      setSortModel: (state, action) => {
        state.sortModel = action.payload;
      },
      setSearchText: (state, action) => {
        state.searchText = action.payload;
      },
      resetPage: state => {
      state.pagination.page = 0;
    },
      resetState: state => Object.assign(state, initialState),
    },
  });

  return slice;
};

export const monitorSlice = inventorySlice("monitor", "created", "desc");
export const cpuSlice = inventorySlice("cpu", "created", "desc"); 
export const keyboardSlice = inventorySlice("keyboard", "created", "desc");
export const mouseSlice = inventorySlice("mouse", "created", "desc");
export const headphoneSlice = inventorySlice("headphone", "created", "desc");
export const dongleSlice = inventorySlice("dongle", "created", "desc");
export const laptopSlice = inventorySlice("laptop", "created", "desc");
export const miscellaneousSlice = inventorySlice("miscellaneous", "created", "desc");

export const inventoryReducers = {
  monitor: monitorSlice.reducer,
  cpu: cpuSlice.reducer,
  keyboard: keyboardSlice.reducer,
  mouse: mouseSlice.reducer,
  headphone: headphoneSlice.reducer,
  dongle: dongleSlice.reducer,
  laptop: laptopSlice.reducer,
  miscellaneous: miscellaneousSlice.reducer,
};
